export enum SEARCH_INDEX {
    ITEMS = 'item_created',
    REACTIONS = 'reactions',
}
export enum ITEM_SOURCE {
    LIKED = 'liked',
    PURCHASED = 'purchased',
    UPLOADED = 'uploaded',
}
